import React from "react";

const COLOR_STOP_MAPPING: Record<string, string> = {
  "#FF9D00": "#FFE7BF",
  "#FF3B30": "#FFE2E1",
  "#FF4081": "#FFCEDF",
  "#AA00FF": "#F1D6FF",
  "#7C4DFF": "#E5DCFF",
  "#2A94F4": "#ABD7FF",
  "#03A28A": "#00FFD9",
  "#00C853": "#E8FFF1",
  "#00E5A0": "#D5FFF2",
  "#222222": "#ECECEC",
};

const BACKGROUND_COLOR_MAPPING: Record<string, string> = {
  "#FF9D00": "#FFF7EB",
  "#FF3B30": "#FFEFEE",
  "#FF4081": "#FFF0F5",
  "#AA00FF": "#F8EBFF",
  "#7C4DFF": "#F0EAFF",
  "#2A94F4": "#EEF6FE",
  "#03A28A": "#EBF8F6",
  "#00C853": "#E2FFEE",
  "#00E5A0": "#E8FFF8",
  "#222222": "#EFEFEF",
};

interface WinningStarProps {
  color: string; // Main color for border and star stroke (e.g., "#FF9D00")
  disabled?: boolean; // When true, apply 10% opacity to outer ring, 40% opacity to inner star
  size?: number; // Optional size (default: 24)
  opacity?: number; // Optional opacity (default: 1)
}

const WinningStar: React.FC<WinningStarProps> = ({ color, size = 24, opacity = 1 }) => {
  // Look up stopColor and backgroundColor from mappings
  const stopColor = COLOR_STOP_MAPPING[color] || "#ECECEC";
  const backgroundColor = BACKGROUND_COLOR_MAPPING[color] || "#EFEFEF";

  // Generate unique gradient ID for each instance to avoid conflicts
  const gradientId = React.useMemo(
    () => `paint0_linear_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer ring background */}
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        fill={backgroundColor}
        opacity={opacity}
      />
      {/* Outer ring border */}
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke={color}
        opacity={opacity}
      />
      {/* Star path with gradient fill */}
      <path
        d="M13.9844 9.35205L14.0547 9.50537L14.2217 9.5249L18.9268 10.0825L15.4482 13.3003L15.3252 13.4136L15.3574 13.5786L16.2812 18.2251L12.1465 15.9116L12 15.8296L11.8535 15.9116L7.71777 18.2251L8.64258 13.5786L8.6748 13.4136L8.55176 13.3003L5.07324 10.0825L9.77832 9.5249L9.94531 9.50537L10.0156 9.35205L12 5.04932L13.9844 9.35205Z"
        fill={`url(#${gradientId})`}
        stroke={color}
        strokeWidth="0.6"
        opacity={opacity}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="9"
          y1="9.00015"
          x2="16.5"
          y2="18.5002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={stopColor} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WinningStar;
